import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GROUP_SEARCH_RESOURCE } from "../group/use-group-search.query";

export const APP_ROLE_UPDATE_RESOURCE = "app-role" as const;

export type AppRoleUpdateBody = paths["/v1/app-role/{uuid}"]["patch"]["requestBody"]["content"]["application/json"];
export type AppRoleUpdateResponse =
  paths["/v1/app-role/{uuid}"]["patch"]["responses"][200]["content"]["application/json"];

export const useAppRoleUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AppRoleUpdateResponse, Error, AppRoleUpdateBody & { uuid: string }>({
    mutationFn: async (appRole: AppRoleUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = appRole;
      const response = await alphartisApiAxios.patch<AppRoleUpdateResponse>(
        `/v1/${APP_ROLE_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async (_data, variables) => {
      const invalidationPromises = [
        queryClient.invalidateQueries({
          queryKey: [APP_ROLE_UPDATE_RESOURCE],
        }),
      ];

      if (variables.groups !== undefined) {
        invalidationPromises.push(
          queryClient.invalidateQueries({
            queryKey: [GROUP_SEARCH_RESOURCE],
          }),
        );
      }

      await Promise.all(invalidationPromises);
    },
  });
};
